import { AdjacencyMatrixGraph, Edge } from "Math/Graph";
import * as React from "react";
import * as Sauce from "Sauce";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import { Position2 } from "Math/Geometry";
import * as _ from "lodash";
import * as Rx from "rxjs";
import * as Util from "Util";
import update = require('immutability-helper');
import { ValueProcessor } from "Sauce/Validation";
import { NumberInput, StringTextInput } from "Sauce/Form";
import { ParseResult } from "Sauce/Validation";
import { Real as RealNumber, Label } from "Sauce/Validation/Basic";
import { Latex } from "UI/Math/Latex";
import * as d3 from "d3";
import { Popover, PopoverTitle, PopoverContent, Button, Tooltip } from "reactstrap";
import { Vec2, AxisAlignedBox2 } from "Math/Algebra";
import { Real } from "Sauce/Validation/Basic";
import { DisplayNumberSvgText, DisplayNumberPopoverContent, getRenderText } from "UI/Math/DisplayNumber";
import * as ReactDOMServer from "react-dom/server";

require("./MatrixViewer.scss");
export interface Props<E> {
    entries: E[][]; /* row major */
    outerWidth: number;
    outerHeight?: number;
    columnLabels?: NodeLabel[];
    rowLabels?: NodeLabel[];
    entryProps: (e: E) => MatrixEntryLabelProps<E>;
}
interface State {
    containerWidth?: number;
    openPopupId: string;
    entryDisplayMode: { [id: string]: "expression" | "numeric" };
}
type Renderable = string;
interface Entry<T>{
    i: number;
    j: number;
    value: T;
}

export interface NodeLabel {
    label: string;
    id: string;
    /* flush + processor enable writeable content.  */
    // processor?: ValueProcessor<string>; /* without these, readonly labels */
    // flush?: (val: ParseResult<string>) => void;
}
export interface MatrixEntryLabelProps<E> {
    weight: ParseResult<number>;
    /* flush + processor enable writeable content.  */
    // processor?: ValueProcessor<string>;
    // flush?: (val: ParseResult<string>) => void;
}
export class MatrixViewer<N, E> extends Sauce.Component<Props<E>, State> {
    private uniqueId = Util.makeDomId(_.uniqueId("graph-viewer-"));
    private containerId = `${this.uniqueId}-popover-container`;
    private weightValidator = new Real().make();
    private openPopupId: string = "";
    private handler = (el: Element) => this.setState({ containerWidth: $(el).innerWidth() });
    private margin = {
        top: 80,
        right: 0,
        bottom: 10,
        left: Math.SQRT2 * 80
    };
    constructor(props: Props<E>) {
        super(props);
        this.state = { containerWidth: undefined, openPopupId: "", entryDisplayMode: {} };
    }

    componentDidUpdate() {
        this.update(ReactDOM.findDOMNode(this), this.props, this.state);
    }

    makeCellsForRow(props: Props<E>, state: State, self: this, x: d3.ScaleBand<number>): 
    (row: Entry<E>[], i: number, ) => void {
        return function (row: Entry<E>[], i: number) {
            let { entryProps } = props;
            let cells = d3.select(this).selectAll(".cell")
                .data(row.filter(cell => cell.value), d => {
                    let e = d as any;
                    if (e.i !== undefined) {
                        return e.i + "_" + e.j;
                    }
                    return "";
                });
            cells.enter().append("g")
                .attr("class", "cell")
                .call(g => {
                    g.append("g")
                        .attr("text-anchor", "middle")
                        .attr("alignment-baseline", "middle")
                })
                .merge(cells) /* merge entry and update sections */
                .attr("width", x.bandwidth())
                .attr("height", x.bandwidth())
                .attr("transform", d => "translate(" + x(d.j) + ", 0 )")
                .call(g => {
                    g.select("g")
                        .html(d => {
                            let entryId = `${d.i}-${d.j}`;
                            let entryDisplayId = `${self.uniqueId}-${entryId}`;
                            let display = <DisplayNumberSvgText
                                toggle={() => self.setState({ openPopupId: entryId })}
                                maxWidth={x.bandwidth()}
                                num={entryProps(d.value).weight}
                                displayRaw={state.entryDisplayMode[entryId] !== "numeric"}
                                id={entryDisplayId}
                                minPrecision={3}/>
                            return ReactDOMServer.renderToStaticMarkup(display);
                        })
                    g.select("text")
                        .attr("x", x.bandwidth() / 2)
                        .attr("y", x.bandwidth() / 2)
                        .attr("class", "tappable")
                        .attr("id", d => `${self.uniqueId}-${d.i}-${d.j}`)
                        .on("click", d => self.setState({ openPopupId: `${d.i}-${d.j}` }));
                });
        }
    }
    displayEntries<T>(entries: T[][]) {
        return  entries.map((row, i) => row.map((cell, j) => ({ value: cell, i: i, j: j})));
    }
    update(el: Element, newProps: Props<E>, state: State) {
        let { margin } = this;
        let { entryProps, entries, outerWidth, outerHeight, columnLabels, rowLabels } = newProps;
        if (!_.isFinite(outerHeight)) outerHeight = outerWidth;
        const height = outerHeight - margin.top - margin.bottom;
        const width = outerWidth - margin.left - margin.right;

        let matrix = this.displayEntries(entries);
        let rowLen = entries.length;
        let colLen = rowLen > 0 ? entries[0].length : 0;

        let x = d3.scaleBand<number>()
            .rangeRound([0, width])
            .domain(d3.range(colLen))
            .align(0);

       let y = d3.scaleBand<number>()
            .rangeRound([0, height])
            .domain(d3.range(rowLen))
            .align(0);

        let row = d3.select("#" + this.uniqueId).selectAll(".row").data(matrix);
        row.exit().remove();
        let rowG = row.enter().append("g")
                .attr("class", "row");

        rowG.append("line")
            .attr("x2", width);

        rowG.merge(row)
                .attr("transform", function (d, i) { return "translate(0," + y(i) + ")"; })
                .each(this.makeCellsForRow(newProps, state, this, x));

        let column = d3.select("#" + this.uniqueId).selectAll(".column").data(matrix);
        column.exit().remove();

        let columnG = column.enter().append("g")
            .attr('class', "column");
        columnG.append("line")
            .attr("x1", -width);
        columnG.merge(column)
            .attr("transform", function (d, i) { return `translate(${x(i)}) rotate(-90)`; })

     /* labels */
        if (rowLabels) {
            let rowLabel = d3.select("#" + this.uniqueId).selectAll(".row-label").data(rowLabels, l => (l as any).id);
                rowLabel.enter()
                    .append("text")
                    .attr('class', 'row-label')
                    .attr("text-anchor", "end")
                    .attr("alignment-baseline", "middle")
                    .merge(rowLabel)
                    .attr("transform", (d, i) => `translate(0, ${x(i) + x.bandwidth() / 2})`)
                    .text(d => d.label);
                rowLabel.exit().remove();
        }
        
        if (columnLabels) {
            let columnLabel = d3.select("#" + this.uniqueId).selectAll(".column-label").data(columnLabels, n => (n as any).id);
                columnLabel.enter()
                    .append("g")
                    .attr("class", "column-label")
                    .call(g => {
                        g.append("line")
                            .attr("class", "label-underline")
                            .attr("stroke-width", 1)
                        g.append("text")
                            .attr("text-anchor", "start")
                            .attr("alignment-baseline", "middle");
                    })
                    .merge(columnLabel)
                    .call(g => {
                        g.select(".label-underline")
                            .attr("x2", Math.SQRT2 * margin.top)
                            .attr("transform", (d, i) => {
                                return `translate(${x(i) + 2}, 0)rotate(-45)`
                            })
                        g.select("text")
                            .attr("transform", (d, i) => `translate(${x(i)}, -5) rotate(-45)`)
                            .text(d => d.label)
                    });
                columnLabel.exit().remove();
        }
    }
    render() {
        let { margin, uniqueId } = this;
        let { entryProps, entries, outerWidth, outerHeight, columnLabels, rowLabels } = this.props;
        if (!_.isFinite(outerHeight)) outerHeight = outerWidth;
        const height = outerHeight - margin.top - margin.bottom;
        const width = outerWidth - margin.left - margin.right;

        let matrix = this.displayEntries(entries);
        let rowLen = entries.length;
        let colLen = rowLen > 0 ? entries[0].length : 0;

        let x = d3.scaleBand<number>()
            .rangeRound([0, width])
            .domain(d3.range(colLen))
            .align(0);

       let y = d3.scaleBand<number>()
            .rangeRound([0, height])
            .domain(d3.range(rowLen))
            .align(0);
        
        let realX = x.bandwidth() * colLen;
        let realY = y.bandwidth() * rowLen;
        let popovers = matrix.map(row => row.map(e => {
            if (e.value) {
                let entryId = `${e.i}-${e.j}`;
                return <DisplayNumberPopoverContent
                    toggle={() => this.state.openPopupId ? this.setState({ openPopupId: ""}) : this.setState({ openPopupId: entryId}) }
                    maxWidth={x.bandwidth()}
                    num={entryProps(e.value).weight}
                    displayRaw={this.state.entryDisplayMode[entryId] !== "numeric"}
                    toggleRaw={() => {
                        let displaymode = this.state.entryDisplayMode[entryId];
                        let other = displaymode === "numeric" ? "expression" : "numeric";
                        let mergePart: any = {};
                        mergePart[entryId] = other;
                        let newState = update(this.state, {entryDisplayMode: {$merge: mergePart}});
                        this.setState(newState);
                    }}
                    id={`${this.uniqueId}-${entryId}`}
                    open={this.state.openPopupId === `${entryId}`}
                    minPrecision={3}/>
            }
        }));
       
        return <div className="graph-matrix-viewer"><svg 
            width={outerWidth}
            height={outerHeight}>

            <rect width={outerWidth}
            height={outerHeight} stroke="black" fill="none" />

            <g id={this.uniqueId}
                transform={`translate(${outerWidth - realX}, ${margin.top})`}>
                <rect className="background" width={realX} height={realY} />
            </g>
        </svg>
        {popovers}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/code/UI/Math/MatrixViewer.tsx